(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/hooks/use-debounce.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/hooks/use-debounce.js');

'use strict';

const _React = React,
  useRef = _React.useRef;
const useDebounce = _ref => {
  let callback = _ref.callback,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 500 : _ref$delay,
    _ref$immediate = _ref.immediate,
    immediate = _ref$immediate === void 0 ? false : _ref$immediate;
  const callbackRef = useRef();
  const debouncedCallbackRef = useRef();
  if (callbackRef.current !== callback) {
    callbackRef.current = callback;
    debouncedCallbackRef.current = _.debounce(callback, delay, immediate);
  }
  return debouncedCallbackRef.current;
};
Object.assign(svs.lyckoplatsen.hooks, {
  useDebounce
});

 })(window);